document.addEventListener("DOMContentLoaded", () => {

 const cartButton = document.querySelector("#cart-icon-bubble");

  // --- SIDE CART ---
  setInterval(() => {
    const sideCart = document.querySelector(".cd-cart-overlay.is-open");

    if (sideCart && !sideCart.hasAttribute("data-logged")) {
      sideCart.setAttribute("data-logged", "true");

      const focusable = sideCart.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusable) {
        focusable.focus();
      } else {
        sideCart.setAttribute("tabindex", "-1");
        sideCart.focus();
      }
    }

    // detect side cart closing
    const closedCart = document.querySelector(".cd-cart-overlay:not(.is-open)[data-logged]");
    if (closedCart) {
      closedCart.removeAttribute("data-logged");
      if (cartButton) cartButton.focus();
    }
  }, 300);
  // Cart LABEL
  setInterval(() => {
    document.querySelectorAll('.cd-cart .cd-cart-item .cd-cart-quantity input').forEach((input, index) => {
      if (!input.id) {
        input.id = 'cart-quantity-'+index;
      }

      if (!input.hasAttribute("aria-label")) {
        input.setAttribute("aria-label", "Menge");
      }
    });
  }, 1000);

  // --- MODAL (#aca-modal) ---
  let lastActiveElement = null;

  const observer1 = new MutationObserver(() => {
    const modal = document.querySelector("#aca-modal");

    if (modal && !modal.hasAttribute("data-focused")) {

      // save the element that had focus before modal
      lastActiveElement = document.activeElement;

      modal.setAttribute("data-focused", "true");
      modal.setAttribute("tabindex", "-1");
      modal.focus();
    }

    // if modal is gone
    if (!modal && lastActiveElement) {
      const sideCart = document.querySelector(".cd-cart-overlay.is-open");

      if (sideCart) {
        sideCart.focus();
      } else {
        lastActiveElement.focus();
      }

      lastActiveElement = null;
    }
  });

  observer1.observe(document.body, {
    childList: true,
    subtree: true,
  });


  const translationEl = document.getElementById('translation-data');
  const translations = {
    add: translationEl.getAttribute('data-add'),
    remove: translationEl.getAttribute('data-remove')
  };
  const statusRegion = document.getElementById('cart-status-alert');
  const cartBubble = document.querySelector('.cart-count-bubble');

  if (cartBubble && statusRegion) {
    let previousCount = parseInt(cartBubble.textContent.trim()) || 0;
    let timeout;

    const announceCartChange = () => {
      const newCount = parseInt(cartBubble.textContent.trim()) || 0;

      if (newCount === previousCount) return; // no real change

      // Always clear text first so SR announces again
      statusRegion.textContent = '';

      requestAnimationFrame(() => {
        if (newCount > previousCount) {
          statusRegion.textContent = translations.add;
          console.log("Item added to cart ✅");
        } else if (newCount < previousCount) {
          statusRegion.textContent = translations.remove;
          console.log("Item removed from cart ✅");
        }

        previousCount = newCount;
      });
    };

    const observer = new MutationObserver(() => {
      clearTimeout(timeout);
      // debounce multiple bubble updates into one
      timeout = setTimeout(announceCartChange, 100);
    });

    observer.observe(cartBubble, { childList: true, characterData: true, subtree: true });
  }



// side cart quantity
 



});
